<template>
  <div>
    <div class="title">
<!--      <img src="../../assets/toplogoe.gif" alt="">-->
      <div class="titleLeft">
        <img src="../../assets/toplogoe.jpg" alt="">
        <h2>{{lang==='zh'?'天津市赢事达办公用品厂':"Inkstar Office Appliance Factory Of Tianjin"}}</h2>
      </div>
      <div class="menuList">
        <div v-for="(item,index) in menuList" :key="index" @click="$router.push({path:item.path})"
        :class="$route.fullPath===item.path?'chosed':''">
          <span>{{lang==='zh'?item.name:item.enName}}</span>
        </div>
      </div>
      <p class="lang">
        <span :style="lang==='zh'?'color:#e87717':''" @click="changeLang('zh')">{{$t('global.chinese')}}</span>/<span :style="lang==='en'?'color:#e87717':''" @click="changeLang('en')">en</span>
      </p>

      <div class="menuImg" @click="phoneMenu=true">
        <img src="../../assets/menu.png" alt="">
      </div>
    </div>
    <div class="fixBox"></div>

    <el-drawer v-model="phoneMenu" :with-header="false" size="210px" z-index="9999" :show-close="true" direction="ttb">
      <div class="phoneMenuList" v-for="(item,index) in menuList" :key="index" style="cursor: pointer;">
        <span @click="closeMenu(item.path)">{{item.name}}</span>
      </div>
      <p class="phoneLang">
        <span :style="lang==='zh'?'color:#e87717':''" @click="changeLang('zh')">{{$t('global.chinese')}}</span>/<span :style="lang==='en'?'color:#e87717':''" @click="changeLang('en')">en</span>
      </p>
    </el-drawer>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "ysdMenu",
  data(){
    return{
      lang:'zh',
      phoneMenu:false,
      menuList:[
        {
          name:"首页",
          enName:"HOME",
          path:"/home"
        },
        {
          name:"产品中心",
          enName:"PRODUCT",
          path:"/product",
        },
        {
          name:"产品支持",
          enName:"SUPPORT",
          path:"/support"
        },
        {
          name:"应用领域",
          enName:"APPLICATION",
          path:"/application"
        },
        {
          name:"关于我们",
          enName:"ABOUT",
          path:"/about"
        },
      ]
    }
  },
  mounted(){
    let lang = Cookies.get("lang")?Cookies.get("lang"):"zh";
    this.lang = lang;
    this.$i18n.locale = lang;
  },
  methods:{
    closeMenu(path){
      this.phoneMenu = false;
      this.$router.push({path:path})
    },
    changeLang(lang){
      Cookies.set("lang",lang);
      location.reload();
    }
  }
}
</script>

<style scoped>
  .fixBox{
    width:100%;
    height: 81px;
  }
  .title{
    position: fixed;
    z-index: 9999;
    width:100%;
    height: 80px;
    background: rgba(255,255,255,1);
  }
  .title>.titleLeft{
    width:40%;
    height:100%;
    display: flex;
    align-items: center;
  }
  .titleLeft>img{
    height: 80%;
  }
  .titleLeft>h2{
    color:#595959;
    font-weight: normal;
    font-size:22px;
  }
  .title,.menuList{
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 80px;
    border-bottom: 1px solid #dedede;
  }
  .menuList{
    height: 100%;
  }
  .menuList>div{
    font-size:18px;
    cursor: pointer;
    height: 100%;
    padding:0 15px;
  }
  .menuList>div:hover .chileMenu{
    display: flex;
  }
  .menuList>div:hover span{
    color:#e87717;
  }
  .menuList>div.chosed span{
    color:#e87717!important;
  }
  .menuList>div:hover{
    border-bottom:3px solid #e87717;
  }
  .menuList>div.chosed{
    border-bottom:3px solid #e87717!important;
  }
  .menuList .chileMenu{
    display: none;
    position: fixed;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    width: 100%;
    left:0;
    background: white;
    top:81px;
  }
  .menuList .chileMenu p{
    line-height: 80px;
    margin:0 15px;
  }
  .menuList .chileMenu p:hover{
    color:#e87717
  }

  .lang{
    font-size:18px;
  }
  .lang span{
    cursor: pointer;
  }
  .phoneMenuList{
    font-size:18px;
    margin:10px 0;
  }
  .phoneLang{
    position: absolute;
    right:10px;
    bottom:10px;
    font-size:16px;
  }
  .menuImg{
    display:none;
  }
  .menu>>>.el-drawer__body{
    padding:10px 5px;
  }
  @media screen and (max-width: 1100px){
    .titleLeft h2{
      display: none;
    }
    .titleLeft{
      width:40%!important;
    }
  }
  @media screen and (max-width: 1050px){
    .menuList,.lang{
      display: none;
    }
    .menuImg{
      display: flex;
      width:50px;
      height:50px;
    }
    .menuImg img{
      width:100%;
      height:100%;
    }

  }
  @media screen and (max-width:550px){
    .title>img{
      width:calc(100% - 110px);
    }
  }
</style>